// extracted by css-extract-rspack-plugin
export default {"root":"root-A9sxeN content-NFrjKj","inputGroup":"inputGroup-mQxQYr inputGroup-p0rCaE"};